import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useFilterActiveSessionStore = defineStore('filterActiveSession', () => {
  const states = ref<Map<string, boolean>>(new Map());

  const makeKey = (slideValue: number, storageKey: string) => `${slideValue}::${storageKey}`;

  const getActive = (slideValue: number, storageKey: string): boolean | undefined => {
    return states.value.get(makeKey(slideValue, storageKey));
  };

  const setActive = (slideValue: number, storageKey: string, value: boolean) => {
    states.value.set(makeKey(slideValue, storageKey), value);
  };

  const clearBySlideValue = (slideValue: number) => {
    const prefix = `${slideValue}::`;
    for (const key of Array.from(states.value.keys())) {
      if (key.startsWith(prefix)) {
        states.value.delete(key);
      }
    }
  };

  const clearAll = () => {
    states.value.clear();
  };

  return {
    getActive,
    setActive,
    clearBySlideValue,
    clearAll,
  };
});
